import Vue from 'vue';

const FETCH_CLIENT_URL = '/client/fetch';
const LIST_CLIENT_URL = '/client/list';
const SET_LIMIT_URL = '/client/set-limit';
const DELETE_CLIENT_URL = '/client/';
const GET_CLIENT_BALANCE_URL = '/client/balance';
const REFRESH_BALANCE_URL = '/client/refresh-balance';
const GET_CLIENT_TRANSACTION_HISTORY_URL = '/client/transaction-history';
const CLIENT_TRANSACTION_HISTORY_REPORT_URL = '/client/transaction-history-report';
const CLIENT_TRANSACTION_HISTORY_MONTHLY_REPORT_URL = '/client/transaction-history-monthly-report';

class ClientService {

    async fetch() {
        return await Vue.prototype.$axios.post(FETCH_CLIENT_URL);
    }

    async list(data) {
        return await Vue.prototype.$axios.post(LIST_CLIENT_URL, data);
    }

    async setLimit(data) {
        return await Vue.prototype.$axios.post(SET_LIMIT_URL, data);
    }

    async deleteClient(id) {
        return await Vue.prototype.$axios.delete(DELETE_CLIENT_URL, {params: {id: id}});
    }

    async getBalance(clientId) {
        return await Vue.prototype.$axios.get(GET_CLIENT_BALANCE_URL, {params: {clientId: clientId}});
    }

    async refreshBalance(data) {
        return await Vue.prototype.$axios.post(REFRESH_BALANCE_URL, data);
    }

    async getTransactionHistory(clientId, pageSize, pageNumber) {
        return await Vue.prototype.$axios.get(GET_CLIENT_TRANSACTION_HISTORY_URL, {params: {clientId: clientId, pageSize: pageSize, pageNumber: pageNumber}});
    }

    async getTransactionHistoryReport(data) {
        return await Vue.prototype.$axios.post(CLIENT_TRANSACTION_HISTORY_REPORT_URL, data);
    }

    async getTransactionHistoryMonthlyReport(data) {
        return await Vue.prototype.$axios.post(CLIENT_TRANSACTION_HISTORY_MONTHLY_REPORT_URL, data);
    }
}

export default new ClientService();
